import { defaultTheme, MultiSelectTheme } from '@medly-components/theme';

import colors from './colors';

export const multiSelect: MultiSelectTheme = {
    ...defaultTheme.multiSelect,
    outlined: {
        ...defaultTheme.multiSelect.outlined,
        chip: {
            ...defaultTheme.multiSelect.outlined.chip,
            active: {
                background: colors.grey[200],
                border: colors.darkBlue,
                color: colors.darkBlue,
                hoverBorder: colors.darkBlue
            }
        },
        icon: {
            ...defaultTheme.multiSelect.outlined.icon,
            active: {
                background: colors.darkBlue,
                hoverBackground: colors.darkBlue,
                color: colors.white,
                hoverColor: colors.white
            }
        }
    }
};
